export default __webpack_public_path__ + "svg/calendar/2026/6/noviembre.svg?e54909a7";